import * as DocumentPicker from 'expo-document-picker';
import { dataURLtoFile } from '../config/utils';
import { API } from './api';

export async function uploadAvatar(type, id, setLoading) {
  const result = await DocumentPicker.getDocumentAsync();

  const file = dataURLtoFile(result.uri);
  const data = new FormData();
  data.append('file', file, file.name);
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  };
  setLoading(true);
  const res = await API.post('/upload', data, config);
  switch (type) {
    case 'worker':
      await API.put(`/update/colaborador/${id}`, {
        foto: res.data.data.url,
      });
      break;
    case 'trainer':
      await API.put(`/update/profissional/${id}`, {
        foto: res.data.data.url,
      });
      break;
    case 'enterprise':
      await API.put(`/update/empresa/${id}`, {
        foto: res.data.data.url,
      });
      break;

    default:
      console.log();
      break;
  }

  return setLoading(false);
}
